import { isArrayOfTwoOrMore } from '@r1-frontend/shared/guards';
import { TArrayOneOrMore } from '@r1-frontend/shared/types/Array';

const linear = (colors: TArrayOneOrMore<string>) => {
    return `linear-gradient(to right,${colors.join(',')})`;
};

export const createGradient = (colors?: string[] | null) => {
    if (isArrayOfTwoOrMore(colors)) {
        return linear(colors);
    }

    const [start = 'transparent', end] = colors || new Array(2).fill('transparent');

    return linear([start, end || start]);
};
